/** Tracker run journal health strip. Prop-driven, no fetching. */
import type { TrackerRun } from '../../types/flights';

export interface FlightRunHealthProps {
  runs: TrackerRun[];
}

const STATUS_STYLES: Record<TrackerRun['status'], string> = {
  ok: 'bg-emerald-100 text-emerald-800',
  failed: 'bg-red-100 text-red-800',
  running: 'bg-blue-100 text-blue-800',
};

export function FlightRunHealth({ runs }: FlightRunHealthProps) {
  if (runs.length === 0) {
    return <p className="text-sm text-gray-500">No tracker runs recorded yet.</p>;
  }
  const anyBad = runs.slice(0, 4).some((r) => r.status === 'failed');
  return (
    <div>
      {anyBad && (
        <p className="mb-2 text-sm font-semibold text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">
          Recent tracker runs failed — the time series may have gaps.
        </p>
      )}
      <ul className="space-y-1">
        {runs.map((r) => (
          <li key={r.id} className="flex items-center gap-2 text-xs font-mono">
            <span className={`px-1.5 py-0.5 rounded ${STATUS_STYLES[r.status]}`}>{r.status}</span>
            <span className="text-gray-500">{r.started_at.slice(0, 16).replace('T', ' ')}</span>
            <span>{r.provider}/{r.query_shape}</span>
            <span className="text-gray-600">{r.rows_written} rows</span>
            {r.error && <span className="text-red-600 truncate max-w-xs" title={r.error}>{r.error}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
